interface PromoSliders {
    slides?: unknown[];
    show_once?: boolean;
    version?: string | number | null;
}

type PromoInfo = {
    version?: string | number | null;
};

const isPromoInfo = (value: unknown): value is PromoInfo => {
    if (!value || typeof value !== 'object') {
        return false;
    }
    const version = (value as { version?: unknown }).version;
    return version === undefined || version === null || typeof version === 'string' || typeof version === 'number';
};

const getPromoInfo = (storageKey: string): PromoInfo | null => {
    const promoInfoRaw = typeof localStorage !== 'undefined' ? localStorage.getItem(storageKey) : null;
    if (!promoInfoRaw) {
        return null;
    }
    try {
        const parsed: unknown = JSON.parse(promoInfoRaw);
        return isPromoInfo(parsed) ? parsed : null;
    } catch {
        return null;
    }
};

export const showPromoModal = (
    ballId: string | number | undefined,
    sliders: PromoSliders | null | undefined,
    flowKey: string,
    disableInBackFlow?: boolean,
): boolean => {
    if (!ballId || !sliders?.slides?.length) {
        return false;
    }
    const { show_once, version } = sliders;
    if (!show_once) {
        if (disableInBackFlow) {
            const allowModal = typeof sessionStorage !== 'undefined' && sessionStorage.getItem(`allow_${flowKey}`) === 'true';
            sessionStorage?.removeItem(`allow_${flowKey}`);
            return allowModal;
        }
        return true;
    }
    const promoInfo = getPromoInfo(`${flowKey}_${ballId}`);
    if (!promoInfo || promoInfo.version !== version) {
        localStorage?.setItem(`${flowKey}_${ballId}`, JSON.stringify({ isShown: 'true', version }));
        return true;
    }
    return false;
};
